export const combineDateTime = (dateString, timeString, setCombinedResult) => {
  const [year, month, date] = dateString.split("-");
  const [hour, minute] = timeString.split(":");

  const combinedDateTime = new Date(year, month - 1, date, hour, minute);

  const formattedDateTime =
    combinedDateTime.toString() + " GMT+0700 (Western Indonesia Time)";

  setCombinedResult(formattedDateTime);
};
